(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[350],{

/***/ 4199:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/approach",
      function () {
        return __webpack_require__(2622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FooterHalfCircle_FooterHalfCircle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/flex.js
var flex = __webpack_require__(4096);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/text.js
var esm_text = __webpack_require__(4115);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/box.js
var box = __webpack_require__(8017);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/Image/index.ts + 1 modules
var Image = __webpack_require__(8331);
// EXTERNAL MODULE: ./src/components/Button/index.ts + 1 modules
var Button = __webpack_require__(599);
;// CONCATENATED MODULE: ./public/footer-half-circle/bg-grid.png
/* harmony default export */ var bg_grid = ({"src":"/_next/static/media/bg-grid.16124e29.png","height":402,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAKElEQVR42mNQ8Z/LpBwAxDDaZw4KZlD2ms2kBOJ4z2FS8p6NkPSF0AAvVBDdxfVkmgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/containers/FooterHalfCircle/FooterHalfCircle.tsx







var FooterHalfCircle = function(param) {
    var buttonLink = param.buttonLink, buttonTitle = param.buttonTitle, title = param.title, description = param.description;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
        pos: "relative",
        alignItems: "center",
        justify: "center",
        w: "100%",
        minH: [
            "250px",
            null,
            null,
            null,
            null,
            "400px"
        ],
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                pos: "absolute",
                w: "1920px",
                left: "50%",
                transform: "translateX(-50%)",
                top: "0",
                zIndex: "-1",
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: bg_grid,
                    alt: "101Pay",
                    objectFit: "cover",
                    objectPosition: "center"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                align: "center",
                flexDir: "column",
                justify: "center",
                p: [
                    "18px",
                    null,
                    null,
                    null,
                    null,
                    null,
                    "0px 12%",
                    null,
                    "0px 16%",
                    "0px 20%", 
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        as: "h2",
                        textStyle: "h2",
                        mb: [
                            "10px",
                            null,
                            null,
                            null,
                            null,
                            "34px"
                        ],
                        fontSize: [
                            "18px",
                            null,
                            null,
                            null,
                            null,
                            "48px"
                        ],
                        fontWeight: "300",
                        textAlign: "center",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                        maxWidth: [
                            "300px",
                            null,
                            null,
                            "514px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                textStyle: "paragraph",
                                mb: [
                                    "53px"
                                ],
                                fontSize: [
                                    "0.875rem",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "21px"
                                ],
                                textAlign: "center",
                                fontWeight: "300",
                                children: description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                href: "#",
                                minW: [
                                    "291px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "444px"
                                ],
                                onClick: function() {
                                    return router.push(buttonLink);
                                },
                                m: "auto",
                                display: "block",
                                variant: "outline",
                                mb: [
                                    "auto",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "5px"
                                ],
                                children: buttonTitle
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var FooterHalfCircle_FooterHalfCircle = (FooterHalfCircle);

;// CONCATENATED MODULE: ./src/containers/FooterHalfCircle/index.ts



/***/ }),

/***/ 2622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ approach; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/esm/slide-fade.js
var slide_fade = __webpack_require__(454);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/text.js
var esm_text = __webpack_require__(4115);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/flex.js
var flex = __webpack_require__(4096);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/box.js
var box = __webpack_require__(8017);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 11 modules
var Layout = __webpack_require__(8077);
// EXTERNAL MODULE: ./src/components/Image/index.ts + 1 modules
var Image = __webpack_require__(8331);
;// CONCATENATED MODULE: ./public/approach/discover.png
/* harmony default export */ var discover = ({"src":"/_next/static/media/discover.65908958.png","height":737,"width":1184,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAjUlEQVR42g3LvQqCUBiA4fc7f0JFQwRBl9Hcvbs1NDVoSxAEkpEokoRZnnNyebZH+jLzqukQZZgABEIg+pGwWWF+Xa3kcELQYA04RxgGggRkv8O0xRmeF4yzjFHBtLQVQtUSiwRTZilSV/TDB53MsK85eunw3RvyOyY95vgx8n00LLZrlNZ4HQkI/nrjD8S5PE2nn+OvAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/approach/partner-co-create.png
/* harmony default export */ var partner_co_create = ({"src":"/_next/static/media/partner-co-create.7d60e137.png","height":1468,"width":2384,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/APbv5ujTuOrVvfTp4PHg0fDaw+vKq+XBkwDq2cTdv5rr07bXxLPkwJfqzKXlwpvRqn4Aj2o/lmk1vpx00KqC0ql3169/rX1UjmM3AGhAG3pRKoheLbWDSqZ2QbeERahoLXM+FQBtSyd0TypcRip6Vix2USN1TSZePh9GKA8MZ0MuWOFviQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/approach/launch.png
/* harmony default export */ var launch = ({"src":"/_next/static/media/launch.520c6845.png","height":735,"width":1130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAApklEQVR4nAWAOQ4BURiAv2fwxvJMMEIsCYWCkGi0DuIsWrfQaVxCO41CoZmEggJRyIw1EcsvauvNvueNh1Pt4Tb76EwZK25z2fsEu6Wo9Xwin+sRSxuIGZImh3YKvH9vbgcftZiO5LTyECXYuSKJyJNkyiXd6PG6nUSNh20JwzudVoNKrY5OpNitfR5BQKmcRw26xW/BsXFNHD4PskYTPqMgoiIW8gc2bzqbrhL5qAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/approach/bg-circle-top.png
/* harmony default export */ var bg_circle_top = ({"src":"/_next/static/media/bg-circle-top.fd1888fa.png","height":554,"width":407,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAgUlEQVR42kWOywrCUAxEZ2IuVZfSlf//a7XVFguKfaA3MXCLns0cJiSETfdAkAjUIjwgxM1XvfRzSjs5iyC5wxyAEHsdxqkOVzN8SBAF17afK3fkrQktaHN9OgmW5k9sTEvkkWSO5G9wG5e7ZUvmUBK23aO2w+sd3gl4MkOF8tX6BcJpOrC5tc5YAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/approach/bg-circle-center.png
/* harmony default export */ var bg_circle_center = ({"src":"/_next/static/media/bg-circle-center.00d338a1.png","height":1302,"width":1013,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAg0lEQVR42lWO2wrCQAxEZ7YBFfFJEPz/X9O6uPVGq3bRJIbiS0+YMAyBDNvc71LDNQGaeVXzDkCV7lE37piGCUs37L9qrRzyYCQm4kDDN6GtnMrLMUdDC2lL7whmRCK5vD0MEcR2dyTARzmen2QE/x8MNFpe5HofBzWsADARlcQNwOcHTOtESLOnCgQAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/containers/FooterHalfCircle/index.ts + 2 modules
var FooterHalfCircle = __webpack_require__(6837);
;// CONCATENATED MODULE: ./src/pages/approach/index.tsx












var discoverPartnerLaunchData = [
    {
        number: "01",
        title: "Discover",
        desc: "The discovery phase helps us set expectations. You provide the vision for product delivery and customer experience. And we craft the team, solution, and roadmap to get there.",
        img: discover,
        imgAltText: "Strategist taking a sticky note off the board"
    },
    {
        number: "02",
        title: "Partner & Co-create",
        desc: "This is where vision and technology come together. We co-create the product by leveraging pre-built architectures and proven methodologies. Working as one team, we learn, iterate, and deliver.",
        img: partner_co_create,
        imgAltText: "group of colleagues planning product launch"
    },
    {
        number: "03",
        title: "Launch",
        desc: "It’s time to go to market! Before launch, the product is tested by real users, so we get a feel for their expectations. After that, its continuous improvement until we achieve the best product experience.",
        img: launch,
        imgAltText: "developer testing the launched application"
    }, 
];
var Approach = function() {
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "101Digital | Approach"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                in: true,
                offsetY: "50px",
                transition: {
                    enter: {
                        duration: 1
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                    as: "h1",
                    textStyle: "h1",
                    textAlign: [
                        "center",
                        null,
                        null,
                        null,
                        null,
                        "left"
                    ],
                    display: "flex",
                    flexDir: [
                        "column",
                        null,
                        null,
                        null,
                        null,
                        "row"
                    ],
                    mb: [
                        "13px",
                        null,
                        null,
                        null,
                        null,
                        "32px"
                    ],
                    mt: [
                        "45px",
                        null,
                        null,
                        null,
                        null,
                        "132px"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                            display: [
                                "none",
                                null,
                                null,
                                null,
                                null,
                                "flex"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                    children: "The"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                    color: "secondary",
                                    mx: "8px",
                                    children: "101 Digital"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                    children: "Way"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                            display: [
                                "inline",
                                null,
                                null,
                                null,
                                null,
                                "none"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                    justify: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            children: "The"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            color: "secondary",
                                            ml: "8px",
                                            children: "101"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                    justify: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            color: "secondary",
                                            mr: "8px",
                                            children: "Digital"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            children: "Way"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                textStyle: "paragraphHighlighted",
                textAlign: [
                    "center",
                    null,
                    null,
                    null,
                    null,
                    "left"
                ],
                px: [
                    "61px",
                    null,
                    null,
                    null,
                    null,
                    0
                ],
                mb: [
                    "37.35px",
                    null,
                    null,
                    null,
                    null,
                    "120px"
                ],
                fontSize: [
                    "16px",
                    null,
                    null,
                    null,
                    null,
                    "24px"
                ],
                fontWeight: "300",
                children: "An approach empowered by industry experience, work principle and agile technology."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        w: [
                            "0%",
                            null,
                            null,
                            null,
                            null,
                            "50%"
                        ],
                        bgImage: "url('/circuit-board-white-small.png')"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        w: [
                            "100%",
                            null,
                            null,
                            null,
                            null,
                            "50%"
                        ],
                        bgColor: "primary",
                        bgImage: "url('/circuit-board-blue-small.png')",
                        p: [
                            "49.65px 129px 53px 21.48px",
                            null,
                            null,
                            null,
                            null,
                            "80px 1rem 120px 12px",
                            "125px 8rem 120px 104px",
                            "125px 8rem 120px 104px",
                            "125px 19rem 120px 104px",
                            "125px 378px 120px 104px", 
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                            in: true,
                            offsetX: "200px",
                            transition: {
                                enter: {
                                    duration: 1
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                color: "white",
                                fontSize: [
                                    "14px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "24px"
                                ],
                                children: "Our collaborations are more than project scope and timelines. We take what we are good at - building exceptional digital financial products, and apply our skills to your ecosystem. So you can focus on customers and not worry about product delivery."
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                w: "100%",
                p: [
                    "46px 16px 0",
                    null,
                    null,
                    null,
                    null,
                    "130px 16px 124px",
                    "130px 16px 60px",
                    null,
                    null,
                    "130px 16px 60px", 
                ],
                mb: "-7px",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        position: "absolute",
                        top: "30px",
                        right: "0",
                        pointerEvents: "none",
                        zIndex: -1,
                        display: [
                            "none",
                            "block"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_top,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        position: "absolute",
                        top: [
                            "1%",
                            "20%"
                        ],
                        left: [
                            "-20%",
                            "0"
                        ],
                        pointerEvents: "none",
                        zIndex: -1,
                        width: [
                            "220px",
                            "auto"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_center,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        as: "h2",
                        textStyle: "h2",
                        textAlign: "center",
                        mb: [
                            "61px",
                            null,
                            null,
                            null,
                            null,
                            "96px"
                        ],
                        fontWeight: "300",
                        fontSize: [
                            "18px",
                            null,
                            null,
                            null,
                            null,
                            "48px"
                        ],
                        children: "Discover, partner, launch!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        mx: "auto",
                        w: "100%",
                        maxW: "1137px",
                        children: discoverPartnerLaunchData.map(function(part, i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                mb: [
                                    "0",
                                    null,
                                    null,
                                    null,
                                    null,
                                    i !== discoverPartnerLaunchData.length - 1 ? "150px" : "0", 
                                ],
                                px: "16px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                    w: "100%",
                                    flexDir: [
                                        "column",
                                        null,
                                        null,
                                        null,
                                        null,
                                        i % 2 !== 0 ? "row-reverse" : "row", 
                                    ],
                                    alignItems: [
                                        "center",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "initial"
                                    ],
                                    justify: [
                                        "space-between"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                                    w: [
                                                        "56px",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "75px"
                                                    ],
                                                    h: [
                                                        "56px",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "75px"
                                                    ],
                                                    justify: "center",
                                                    alignItems: "center",
                                                    boxShadow: "10px 3px 12px rgba(207, 207, 207, 0.4)",
                                                    bgColor: "#ffffff",
                                                    color: "primary",
                                                    mx: [
                                                        "auto",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "unset"
                                                    ],
                                                    borderRadius: [
                                                        "19.3455px",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "25.8989px", 
                                                    ],
                                                    fontSize: [
                                                        "18.33px",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "24.54px"
                                                    ],
                                                    fontWeight: "400",
                                                    mb: [
                                                        "40px",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "30.03px"
                                                    ],
                                                    children: part.number
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                                                    display: [
                                                        "block",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "none"
                                                    ],
                                                    position: "relative",
                                                    width: "100%",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: part.img,
                                                            alt: part.imgAltText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                            display: [
                                                                "block",
                                                                null,
                                                                null,
                                                                null,
                                                                null,
                                                                "none"
                                                            ],
                                                            textAlign: "center",
                                                            whiteSpace: "nowrap",
                                                            fontSize: "18px",
                                                            color: "#fff",
                                                            position: "absolute",
                                                            bottom: "20px",
                                                            left: "50%",
                                                            transform: "translateX(-50%)",
                                                            children: part.title
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                    fontSize: "36px",
                                                    fontWeight: "300",
                                                    mb: "15.38px",
                                                    color: "primary",
                                                    display: [
                                                        "none",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "block"
                                                    ],
                                                    children: part.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                    fontSize: [
                                                        "14px",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "21px"
                                                    ],
                                                    mt: [
                                                        "55px",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        0
                                                    ],
                                                    mx: [
                                                        "auto",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "unset"
                                                    ],
                                                    mb: "55px",
                                                    p: [
                                                        "0 20px",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        0
                                                    ],
                                                    color: "gray",
                                                    fontWeight: "300",
                                                    textAlign: [
                                                        "center",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "initial"
                                                    ],
                                                    maxW: "400px",
                                                    children: part.desc
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                                            display: [
                                                "none",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "block"
                                            ],
                                            position: "relative",
                                            flex: [
                                                "0 0 595px"
                                            ],
                                            maxW: [
                                                "595px"
                                            ],
                                            mr: [
                                                i % 2 !== 0 ? "24px" : "0"
                                            ],
                                            ml: [
                                                i % 2 === 0 ? "24px" : "0"
                                            ],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    src: part.img,
                                                    alt: part.imgAltText
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                    display: [
                                                        "block",
                                                        null,
                                                        null,
                                                        null,
                                                        null,
                                                        "none"
                                                    ],
                                                    fontSize: "18px",
                                                    color: "#fff",
                                                    position: "absolute",
                                                    bottom: "20px",
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    children: part.title
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, part.number);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterHalfCircle/* default */.Z, {
                title: "A product suite to match our approach",
                description: "Our products, catered to any bank and fintech use case, work perfectly with our approach to delivering customer success.",
                buttonTitle: "See what we built",
                buttonLink: "/products"
            })
        ]
    }));
};
/* harmony default export */ var approach = (Approach);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [425,454,77,774,888,179], function() { return __webpack_exec__(4199); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);